class AccountPage extends HTMLElement {
  static observedAttributes = [];

  constructor() {
    super();
    this.handleHashChange = this.handleHashChange.bind(this);
  }

  connectedCallback() {
    addEventListener("hashchange", this.handleHashChange);
    this.handleHashChange(null);
  }

  handleHashChange(e: Event | null) {
    e?.preventDefault();

    const accountRight = this.querySelector(".account__right");
    const accountLeft = this.querySelector(".account__left");

    if (!accountRight || !accountLeft) {
      console.error("Missing account divs");
      return;
    }

    accountRight.className = "account__right";
    accountLeft.className = "account__left";
    accountRight.classList.add(window.location.hash.replace("#", ""));
    accountLeft.classList.add(window.location.hash.replace("#", ""));

    this.querySelectorAll(".account__section-links a")?.forEach((elem) => {
      elem?.classList?.remove("active");
      if (elem?.getAttribute("href")?.includes(window.location.hash)) {
        elem?.classList?.add("active");
      }
    });

    window.scrollTo(0, 0);

    (document.querySelector(".account__left-linkbox .ac-trigger") as HTMLElement)?.click();
  }
}

customElements.define("account-page", AccountPage);
